import { somarCustos, resolverPreco, somarTaxas } from "./engine";
import { limitarMargem } from "./margem";

// Valor-alvo efetivo: no modo margem o digitado é limitado pelo teto que as taxas permitem.
export function valorAlvoEfetivo({ modo, valorAlvoDigitado, taxas }) {
  return modo === "margem" && valorAlvoDigitado !== ""
    ? String(limitarMargem(valorAlvoDigitado, somarTaxas(taxas).totalPct))
    : valorAlvoDigitado;
}

/** Quantas peças saem de uma impressão — sempre um inteiro >= 1. */
export function unidadesDoCalculo(estado) {
  return Math.max(1, parseInt(estado?.unidades, 10) || 1);
}

// Resultado (custos + preço) a partir de UM estado de cálculo — o mesmo formato
// que useCalculoProduto guarda. Função pura: serve tanto ao cálculo em tela
// quanto a cada arquivo de um lote, que guarda o próprio estado completo.
//
// Os campos de topo são SEMPRE o total da impressão (a placa inteira) — é o
// que o resto do app já espera. Quando a placa rende várias peças, `porUnidade`
// traz os mesmos valores divididos por `uns`, pra tela não precisar dividir na
// mão. (O registro de produto e o orçamento em Calculadora.jsx ainda fazem a
// própria divisão; podem migrar pra cá quando alguém encostar neles.)
export function calcularResultado(estado) {
  const horas = parseFloat(estado.horas) || 0;
  const custos = somarCustos({
    filamentos: estado.filamentosCalc,
    materiaisExtras: estado.materiaisCalc,
    custosAdicionais: estado.custosAdicionais,
    maoDeObra: { horas: parseFloat(estado.maoObraHrs) || 0, valorHora: parseFloat(estado.maoObraValorHr) || 0 },
    energia: {
      modo: estado.energiaModo, horas,
      valorHora: parseFloat(estado.energiaValorHora) || 0,
      potenciaW: parseFloat(estado.energiaPotenciaW) || 0, valorKwh: parseFloat(estado.energiaValorKwh) || 0,
    },
    desgaste: {
      modo: estado.desgasteModo, horas,
      valorHora: parseFloat(estado.desgasteValorHora) || 0,
      aquisicao: parseFloat(estado.desgasteAquisicao) || 0,
      vidaUtilHoras: parseFloat(estado.desgasteVidaUtil) || 0,
      manutencaoTotal: parseFloat(estado.desgasteManutencao) || 0,
    },
  });
  const valorAlvo = valorAlvoEfetivo(estado);
  const preco = resolverPreco({
    custoTotal: custos.custoTotal, taxas: estado.taxas, modo: estado.modo,
    valorAlvo: String(valorAlvo).trim() === "" ? 0 : parseFloat(valorAlvo) || 0,
  });

  const uns = unidadesDoCalculo(estado);
  const total = { ...custos, ...preco };
  // Margem e markup são razões: não mudam ao dividir por unidade.
  const porUnidade = uns === 1 ? total : {
    ...total,
    custoTotal: total.custoTotal / uns,
    custoBase: total.custoBase / uns,
    precoFinal: total.precoFinal / uns,
    lucroReal: total.lucroReal / uns,
    valorLiquido: total.valorLiquido / uns,
    "taxaTotalR$": total["taxaTotalR$"] / uns,
    detalhamento: total.detalhamento.map(linha => ({ ...linha, valor: linha.valor / uns })),
  };

  return { ...total, uns, porUnidade };
}
